/**
 * Collection View Toggle (Globo Filter)
 * Appends grid/list view toggle when .gf-filter-selection is present.
 * Only runs on collection and search pages.
 */
(function () {
  var templateClass = document.body && document.body.className ? document.body.className : '';
  var isCollectionOrSearch = templateClass.indexOf('template-collection') !== -1 ||
    templateClass.indexOf('template-search') !== -1;

  if (!isCollectionOrSearch) return;

  var VIEW_TOGGLE_MARKER = 'data-collection-view-toggle-injected';

  function getProductGridOuter() {
    return document.querySelector('[data-productgrid-outer]') ||
      document.querySelector('.productgrid--outer');
  }

  function getInitialView() {
    var gridOuter = getProductGridOuter();
    var hasListParam = typeof URLSearchParams !== 'undefined' &&
      new URLSearchParams(window.location.search).get('grid_list');
    if (gridOuter && gridOuter.classList.contains('productgrid-listview')) return 'list-view';
    if (hasListParam) return 'list-view';
    return 'grid-view';
  }

  function setView(view) {
    var gridOuter = getProductGridOuter();
    if (!gridOuter) return;

    gridOuter.classList.remove('productgrid-gridview', 'productgrid-listview');
    gridOuter.classList.add(view === 'list-view' ? 'productgrid-listview' : 'productgrid-gridview');

    // Update URL for persistence (matches theme's pagination behavior)
    if (typeof URLSearchParams !== 'undefined' && typeof window.history !== 'undefined' &&
        window.history.replaceState) {
      var url = new URL(window.location.href);
      if (view === 'list-view') {
        url.searchParams.set('grid_list', '');
      } else {
        url.searchParams.delete('grid_list');
      }
      window.history.replaceState({}, '', url.toString());
    }
  }

  function createViewToggle() {
    var initialView = getInitialView();
    var isGrid = initialView === 'grid-view';

    var wrapper = document.createElement('div');
    wrapper.className = 'utils-viewtoggle';
    wrapper.setAttribute(VIEW_TOGGLE_MARKER, 'true');

    // var label = document.createElement('span');
    // label.className = 'utils-viewtoggle-label';
    // label.textContent = 'View as';
    // wrapper.appendChild(label);

    var gridSvg = '<svg class="icon-grid" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 7V2H7V7H2ZM0 1C0 0.447715 0.447715 0 1 0H8C8.55229 0 9 0.447715 9 1V8C9 8.55229 8.55229 9 8 9H1C0.447715 9 0 8.55229 0 8V1ZM13 7V2H18V7H13ZM11 1C11 0.447715 11.4477 0 12 0H19C19.5523 0 20 0.447715 20 1V8C20 8.55229 19.5523 9 19 9H12C11.4477 9 11 8.55229 11 8V1ZM13 13V18H18V13H13ZM12 11C11.4477 11 11 11.4477 11 12V19C11 19.5523 11.4477 20 12 20H19C19.5523 20 20 19.5523 20 19V12C20 11.4477 19.5523 11 19 11H12ZM2 18V13H7V18H2ZM0 12C0 11.4477 0.447715 11 1 11H8C8.55229 11 9 11.4477 9 12V19C9 19.5523 8.55229 20 8 20H1C0.447715 20 0 19.5523 0 19V12Z" fill="currentColor"></path></svg>';

    var listSvg = '<svg class="icon-list" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 2C0.223858 2 0 2.22386 0 2.5V3.5C0 3.77614 0.223858 4 0.5 4H1.5C1.77614 4 2 3.77614 2 3.5V2.5C2 2.22386 1.77614 2 1.5 2H0.5ZM5 2C4.44772 2 4 2.44772 4 3C4 3.55228 4.44772 4 5 4H19C19.5523 4 20 3.55228 20 3C20 2.44772 19.5523 2 19 2H5ZM5 9C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11H19C19.5523 11 20 10.5523 20 10C20 9.44772 19.5523 9 19 9H5ZM4 17C4 16.4477 4.44772 16 5 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H5C4.44772 18 4 17.5523 4 17ZM0 9.5C0 9.22386 0.223858 9 0.5 9H1.5C1.77614 9 2 9.22386 2 9.5V10.5C2 10.7761 1.77614 11 1.5 11H0.5C0.223858 11 0 10.7761 0 10.5V9.5ZM0.5 16C0.223858 16 0 16.2239 0 16.5V17.5C0 17.7761 0.223858 18 0.5 18H1.5C1.77614 18 2 17.7761 2 17.5V16.5C2 16.2239 1.77614 16 1.5 16H0.5Z" fill="currentColor"></path></svg>';

    var gridBtn = document.createElement('button');
    gridBtn.type = 'button';
    gridBtn.className = 'utils-viewtoggle-button' + (isGrid ? ' active' : '');
    gridBtn.setAttribute('data-collection-view', 'grid-view');
    gridBtn.setAttribute('aria-label', 'grid view');
    gridBtn.innerHTML = gridSvg;

    var listBtn = document.createElement('button');
    listBtn.type = 'button';
    listBtn.className = 'utils-viewtoggle-button' + (!isGrid ? ' active' : '');
    listBtn.setAttribute('data-collection-view', 'list-view');
    listBtn.setAttribute('aria-label', 'list view');
    listBtn.innerHTML = listSvg;

    gridBtn.addEventListener('click', function () {
      gridBtn.classList.add('active');
      listBtn.classList.remove('active');
      setView('grid-view');
    });

    listBtn.addEventListener('click', function () {
      listBtn.classList.add('active');
      gridBtn.classList.remove('active');
      setView('list-view');
    });

    wrapper.appendChild(gridBtn);
    wrapper.appendChild(listBtn);

    return wrapper;
  }

  function injectViewToggle() {
    var gfFilter = document.querySelector('.gf-filter-selection');
    if (!gfFilter || gfFilter.querySelector('[' + VIEW_TOGGLE_MARKER + ']')) return false;

    var viewToggle = createViewToggle();
    gfFilter.appendChild(viewToggle);
    return true;
  }

  function observeAndInject() {
    var observer = new MutationObserver(function () {
      if (injectViewToggle()) observer.disconnect();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Initial check and fallback: Globo may inject late
    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts++;
      if (injectViewToggle() || attempts >= 20) window.clearInterval(interval);
    }, 250);

    injectViewToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAndInject);
  } else {
    observeAndInject();
  }
})();
